export const cibSlashdot = ["32 32","<path d='M26.37 0l-16.99 32h-6.891l16.984-32zM29.51 26.401c0 3.026-2.458 5.474-5.479 5.474-3.026 0-5.479-2.453-5.479-5.474s2.453-5.474 5.479-5.474c3.021 0 5.479 2.448 5.479 5.474z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-slashdot.js
// module id = null
// module chunks = 